import React, { useEffect, useState } from 'react';
import database from '../service/FirebaseConfig';

function Resume() {
  const [pdfUrl, setPdfUrl] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Replace 'pdfLink' with the actual path to your PDF in the database
    const pdfRef = database.ref('resume');

    pdfRef.once('value').then((snapshot) => {
      const pdfLink = snapshot.val();
      setPdfUrl(pdfLink);
      setLoading(false);
    });
  }, []);

  return (
    <div>
      {loading ? (
        <p>Loading PDF...</p>
      ) : pdfUrl ? (
        <div>
          <embed src={pdfUrl} type="application/pdf" width="100%" style={{minHeight:"100vh"}} />
        </div>
      ) : (
        <p>PDF not found</p>
      )}
    </div>
  );
}

export default Resume;
